import Marquee from "react-fast-marquee";
import { Flame } from "lucide-react";

export default function BrandMarquee() {
  const items = ["Hot Packz Grabba", "Rolled Loud", "Street Certified", "Premium Grabba", "Trust & Loyalty"];
  return (
    <section data-testid="marquee" className="border-y border-surface-border bg-black py-7">
      <Marquee speed={55} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center gap-8 mx-8">
            <span className="font-display uppercase text-3xl sm:text-5xl text-outline-blaze whitespace-nowrap">
              {t}
            </span>
            <Flame className="text-gold shrink-0" size={28} />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
